import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ReservationsVehicleStayList } from 'src/features/reservations/types/reservationType';

interface DTO {
    parkingId: string;
    reservationId: string;
}

const RESOURCE = 'reservations/:parkingId/vehicle-stay-reservation/:reservationId/';

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, reservationId, ...params }: DTO): Promise<ReservationsVehicleStayList> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, reservationId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) => {
    const { parkingId } = payload;
    return useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        enabled: !!parkingId,
        ...config,
    });
};

export { useQueryHook as useReservationVehicleStay };
